import { Tab, Tabs } from "@vfuk/core-tabs";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLayoutManagementStore } from "src/hooks/stores";
import Paragraph from "@vfuk/core-paragraph";

interface ManageAccessLayoutProps {
  activeTab: "/users" | "/roles" | "/customers";
}

const ManageAccessLayout = ({ activeTab }: ManageAccessLayoutProps) => {
  const navigate = useNavigate();
  const { hasFetched: tabsFetched, error: error } = useLayoutManagementStore(
    (state) => state.getManageAccessTabs
  );
  const fetchTabs = useLayoutManagementStore.getState().fetchTabs;
  const tabs = useLayoutManagementStore((state) => state.manageAccessTabs);
  const setActiveTabs = useCallback(
    (tabId: string) => {
      navigate(tabId);
    },
    [navigate]
  );
  useEffect(() => {
    if (!tabsFetched) {
      fetchTabs();
    }
    setActiveTabs(activeTab);
  }, [fetchTabs, tabsFetched, setActiveTabs, activeTab]);
  if (error) return <Paragraph>{error}</Paragraph>;
  return (
    <Tabs
      externallySetTabId={activeTab}
      onTabClick={(tabId) => setActiveTabs(tabId)}
    >
      {tabs.map((tab, i) => (
        <Tab key={i} text={tab.displayName} id={tab.url} />
      ))}
    </Tabs>
  );
};

export default ManageAccessLayout;
